import { useUnit } from 'effector-react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { automationSettingsService } from '@/modules/automation-settings/service/automation-settings-service.ts'
import { handleError } from '@/utils/error'

export function useAutomationSettings() {
  const creatorId = useUnit($creatorId)

  return useQuery(
    ['automation-settings', creatorId],
    () => automationSettingsService.list(creatorId!),
    {
      enabled: !!creatorId,
      keepPreviousData: true,
    },
  )
}

export function useUpdateAutomationSettings() {
  const creatorId = useUnit($creatorId)
  const queryClient = useQueryClient()

  return useMutation(
    (data: {
      serviceType: string
      runBehavior: string
      fromTime?: string
      toTime?: string
    }) => automationSettingsService.update(creatorId!, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['automation-settings-update', creatorId])
      },
      onError: (error) => {
        handleError(
          error,
          'Something went wrong while updating automation settings',
        )
      },
    },
  )
}
